import PropTypes from "prop-types";
import SubscriptionInfo from "./SubscriptionInfo";
import InvoiceInfo from "./InvoiceInfo";
import EcommerceInfo from "./EcommerceInfo";

const DynamicMetadata = ({ metadata }) => {
  const type = metadata?.type;

  if (!type || !metadata?.display) {
    return null;
  }

  switch (type) {
    case "subscription":
      return <SubscriptionInfo metadata={metadata} />;
    case "invoice":
      return <InvoiceInfo metadata={metadata} />;
    case "ecommerce":
      return <EcommerceInfo metadata={metadata} />;
    default:
      return null;
  }
};

DynamicMetadata.propTypes = {
  metadata: PropTypes.shape({
    type: PropTypes.oneOf(["subscription", "invoice", "ecommerce"]),
    display: PropTypes.object,
  }),
};

export default DynamicMetadata;
